import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {};

    static targets = [
        'declineButton',
        'acceptButton',
        'phoneInput',
    ];

    openModal() {
        $('#optinPhoneModal').modal('show');
    }

    async validatePhone() {
        if(!this.phoneInputTarget.value) {
            addAlert('danger', translations['profile.Invalid phone number.']);
            return false;
        }

        if (this.phoneInputTarget.value) {
            showPreloader();
            try {
                const response = await fetch(routes['app_profile_isvalidphonenumber'] + '?' +
                    new URLSearchParams({ phone_number: this.phoneInputTarget.value }),
                    {
                        method: 'GET',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    });

                const json = await response.json();

                if (!json.is_valid_phone_number) {
                    addAlert('danger', translations['profile.Invalid phone number.']);
                }
                return json.is_valid_phone_number;
            } catch (error) {
                console.error(error);
                addAlert('danger', translations['profile.An unknown error occurred.']);
                return false;
            }
        }
    }

    async submit() {
        const isValid = await this.validatePhone();

        if (!isValid) {
            hidePreloader();

            return;
        }

        const optinPhone = this.acceptButtonTarget.classList.contains('btn-primary-dark');

        const data = {
            phonenumb: this.phoneInputTarget.value,
            optin_phone: optinPhone,
        };

        const errorCallback = () => {
            dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    'category': 'Account',
                    'action': 'optin_phone | ' + (optinPhone ? 'true' : 'false') + ' | Failure',
                    'label': GA_EVENT_LABEL,
                },
            });

            addAlert('danger', translations['profile.An unknown error occurred.']);

            hidePreloader();
            refreshPriorityTab();
        };

        $.ajax({
            url: routes['app_profile_editphonenumberandoptinphone'],
            method: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            success: (response) => {
                if (response.status) {
                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'optin_phone | ' + (optinPhone ? 'true' : 'false') + ' | Success',
                            'label': GA_EVENT_LABEL,
                        },
                    });

                    addAlert('success', response.message);

                    window.location.reload();
                } else {
                    errorCallback();
                }
            },
            error: errorCallback,
        });
    }

    declineButtonClicked() {
        this.declineButtonTarget.classList.add('btn-primary-dark');
        this.declineButtonTarget.classList.remove('btn-outline-secondary');

        this.acceptButtonTarget.classList.add('btn-outline-secondary');
        this.acceptButtonTarget.classList.remove('btn-primary-dark');
    }

    acceptButtonClicked() {
        this.acceptButtonTarget.classList.add('btn-primary-dark');
        this.acceptButtonTarget.classList.remove('btn-outline-secondary');

        this.declineButtonTarget.classList.add('btn-outline-secondary');
        this.declineButtonTarget.classList.remove('btn-primary-dark');
    }

    enableInput() {
        this.phoneInputTarget.disabled = false;
    }

    disableInput() {
        this.phoneInputTarget.disabled = true;
    }
}
